import { Box } from "@mantine/core";

import { DayLayout } from "../components";

const Days = () => {
	const fyp = [
		{
			id: 1,
			date: "26 Jul 2023",
			name: "Jersey Day",
			images: [
				{
					id: 1,
					imageUrl: "fyp-images/Day1-Sport/img1.jpg",
					category: "Jersey",
				},
				{
					id: 2,
					imageUrl: "fyp-images/Day1-Sport/img2.jpg",
					category: "Jersey",
				},
				{
					id: 3,
					imageUrl: "fyp-images/Day1-Sport/img3.jpg",
					category: "Jersey",
				},
				{
					id: 4,
					imageUrl: "fyp-images/Day1-Sport/img4.jpg",
					category: "Jersey",
				},
				{
					id: 5,
					imageUrl: "fyp-images/Day1-Sport/img5.jpg",
					category: "Jersey",
				},
				{
					id: 6,
					imageUrl: "fyp-images/Day1-Sport/img6.jpg",
					category: "Jersey",
				},
				{
					id: 7,
					imageUrl: "fyp-images/Day1-Sport/img7.jpg",
					category: "Jersey",
				},
			],
		},
		{
			id: 2,
			date: "28 Jul 2023",
			name: "Denim Day",
			images: [
				{
					id: 1,
					imageUrl: "fyp-images/Day2-Denin/img1.jpg",
					category: "Denin",
				},
				{
					id: 2,
					imageUrl: "fyp-images/Day2-Denin/img2.jpg",
					category: "Denin",
				},
				{
					id: 3,
					imageUrl: "fyp-images/Day2-Denin/img3.jpg",
					category: "Denin",
				},
				{
					id: 4,
					imageUrl: "fyp-images/Day2-Denin/img4.jpg",
					category: "Denin",
				},
				{
					id: 5,
					imageUrl: "fyp-images/Day2-Denin/img5.jpg",
					category: "Denin",
				},
				{
					id: 6,
					imageUrl: "fyp-images/Day2-Denin/img6.jpg",
					category: "Denin",
				},
				{
					id: 7,
					imageUrl: "fyp-images/Day2-Denin/img7.jpg",
					category: "Denin",
				},
			],
		},
		{
			id: 3,
			date: "27 Jul 2023",
			name: "Ankara Day",
			images: [
				{
					id: 1,
					imageUrl: "fyp-images/Day3-Ankara/img1.jpg",
					category: "Ankara",
				},
				{
					id: 2,
					imageUrl: "fyp-images/Day3-Ankara/img2.jpg",
					category: "Ankara",
				},
				{
					id: 3,
					imageUrl: "fyp-images/Day3-Ankara/img3.jpg",
					category: "Ankara",
				},
				{
					id: 4,
					imageUrl: "fyp-images/Day3-Ankara/img4.jpg",
					category: "Ankara",
				},
				{
					id: 5,
					imageUrl: "fyp-images/Day3-Ankara/img5.jpg",
					category: "Ankara",
				},
				{
					id: 6,
					imageUrl: "fyp-images/Day3-Ankara/img6.jpg",
					category: "Ankara",
				},
				{
					id: 7,
					imageUrl: "fyp-images/Day3-Ankara/img7.jpg",
					category: "Ankara",
				},
				{
					id: 8,
					imageUrl: "fyp-images/Day3-Ankara/img8.jpg",
					category: "Ankara",
				},
			],
		},
		{
			id: 4,
			date: "02 Aug 2023",
			name: "Corporate Day",
			images: [
				{
					id: 1,
					imageUrl: "fyp-images/Day4-Corporate/img1.jpg",
					category: "Corporate",
				},
				{
					id: 2,
					imageUrl: "fyp-images/Day4-Corporate/img2.jpg",
					category: "Corporate",
				},
				{
					id: 3,
					imageUrl: "fyp-images/Day4-Corporate/img3.jpg",
					category: "Corporate",
				},
				{
					id: 4,
					imageUrl: "fyp-images/Day4-Corporate/img4.jpg",
					category: "Corporate",
				},
				{
					id: 5,
					imageUrl: "fyp-images/Day4-Corporate/img5.jpg",
					category: "Corporate",
				},
				{
					id: 6,
					imageUrl: "fyp-images/Day4-Corporate/img6.jpg",
					category: "Corporate",
				},
				{
					id: 7,
					imageUrl: "fyp-images/Day4-Corporate/img7.jpg",
					category: "Corporate",
				},
				{
					id: 8,
					imageUrl: "fyp-images/Day4-Corporate/img8.jpg",
					category: "Corporate",
				},
			],
		},
		{
			id: 5,
			date: "03 Aug 2023",
			name: "Sign Out Day",
			images: [
				{
					id: 1,
					imageUrl: "fyp-images/Day5-White/img1.jpg",
					category: "Sign Out",
				},
				{
					id: 2,
					imageUrl: "fyp-images/Day5-White/img2.jpg",
					category: "Sign Out",
				},
				{
					id: 3,
					imageUrl: "fyp-images/Day5-White/img3.jpg",
					category: "Sign Out",
				},
				{
					id: 4,
					imageUrl: "fyp-images/Day5-White/img4.jpg",
					category: "Sign Out",
				},
				{
					id: 5,
					imageUrl: "fyp-images/Day5-White/img5.jpg",
					category: "Sign Out",
				},
				{
					id: 6,
					imageUrl: "fyp-images/Day5-White/img6.jpg",
					category: "Sign Out",
				},
				{
					id: 7,
					imageUrl: "fyp-images/Day5-White/img7.jpg",
					category: "Sign Out",
				},
			],
		},
		{
			id: 6,
			date: "03 Aug 2023",
			name: "Meena's Birthday",
			images: [
				{
					id: 1,
					imageUrl: "fyp-images/Day5-Birthday/img1.jpg",
					category: "Birthday",
				},
				{
					id: 2,
					imageUrl: "fyp-images/Day5-Birthday/img2.jpg",
					category: "Birthday",
				},
				{
					id: 3,
					imageUrl: "fyp-images/Day5-Birthday/img3.jpg",
					category: "Birthday",
				},
				{
					id: 4,
					imageUrl: "fyp-images/Day5-Birthday/img4.jpg",
					category: "Birthday",
				},
				{
					id: 5,
					imageUrl: "fyp-images/Day5-Birthday/img5.jpg",
					category: "Birthday",
				},
				{
					id: 6,
					imageUrl: "fyp-images/Day5-Birthday/img6.jpg",
					category: "Birthday",
				},
				{
					id: 7,
					imageUrl: "fyp-images/Day5-Birthday/img7.jpg",
					category: "Birthday",
				},
				{
					id: 8,
					imageUrl: "fyp-images/Day5-Birthday/img8.jpg",
					category: "Birthday",
				},
				{
					id: 9,
					imageUrl: "fyp-images/Day5-Birthday/img9.jpg",
					category: "Birthday",
				},
				{
					id: 10,
					imageUrl: "fyp-images/Day5-Birthday/img10.jpg",
					category: "Birthday",
				},
			],
		},
	];

	return (
		<Box>
			{fyp.map((day) => (
				<DayLayout
					date={day.date}
					images={day.images}
					key={day.id}
					name={day.name}
					number={day.id}
				/>
			))}
		</Box>
	);
};

export default Days;
